import { useAuth } from "./auth/AuthContext";
import Apply from "./pages/Apply";
import Login from "./pages/Login";
import { APPLY_PATH, usePath } from "./pages/route";
import Shell from "./ui/Shell";

export default function App() {
  const { status, refresh } = useAuth();
  const path = usePath();

  return (
    <>
      {import.meta.env.VITE_MOCK === "1" && (
        <div className="mock-banner" role="note">
          Sample data · mock mode, not connected to Wealthoak
        </div>
      )}
      {status === "checking" ? (
        // The session lives in an httpOnly cookie, so on a cold load we
        // genuinely do not know whether the partner is signed in until the
        // server answers. Showing the login form during that moment would
        // flash it at people who are already signed in, every single reload.
        <div className="app-loading">
          <span>Loading…</span>
        </div>
      ) : status === "unreachable" ? (
        <div className="app-loading" role="alert">
          <span>Wealthoak could not be reached. Check your connection and try again.</span>
          <button type="button" className="button button--primary" onClick={() => void refresh()}>
            Try again
          </button>
        </div>
      ) : status === "no_partner_api" ? (
        <div className="app-loading" role="alert">
          <span>
            The partner service isn't available right now. Please try again later.
            {import.meta.env.DEV && (
              <>
                <br />
                Dev: the API answered 404 for /partner/auth/me — VITE_API_TARGET points at a
                Backend-v2 without the partner routes (feature/partner-panel).
              </>
            )}
          </span>
          <button type="button" className="button button--primary" onClick={() => void refresh()}>
            Try again
          </button>
        </div>
      ) : status === "signed_out" ? (
        path === APPLY_PATH ? <Apply /> : <Login />
      ) : (
        <Shell />
      )}
    </>
  );
}
